import React from 'react';

function PhotoInstructions() {
  return (
    <section id="photo-instructions" className="max-w-4xl mx-auto px-4 pb-8">
      <div className="bg-white border border-gray-200 rounded-lg p-4 text-sm text-gray-700">
        Wskazówka: zdjęcia powinny przedstawiać produkt, bez osób i twarzy.
      </div>
    </section>
  );
}

export default PhotoInstructions;
